import { render, staticRenderFns } from "./Isupplier.vue?vue&type=template&id=829d7498&"
import script from "./Isupplier.vue?vue&type=script&lang=js&"
export * from "./Isupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports